<script setup>

import {useRoute} from "vue-router";
import {storeToRefs} from "pinia/dist/pinia";
import {onMounted, ref} from "vue";
import {useUserFormStore} from "@/stores/userform.store";

const route = useRoute();
const userFormStore = useUserFormStore();
const {userForm} = storeToRefs(userFormStore);
const name = ref(1);
const backEndUrl = `${process.env.VUE_APP_API_URL}`;

onMounted(async ()=> {
    await userFormStore.fetchOne(route.params.id);
});

function waitForIframeResult() {
    return new Promise((resolve) => {
        function messageHandler(event) {
            console.log('data: ' + event.data);
            if (event.data) {
                window.removeEventListener('message', messageHandler);  // Clean up the event listener
                resolve(event.data);
            }
        }

        window.addEventListener('message', messageHandler);
    });
}

const updateResource = async () => {
    const iframe = document.getElementById('formFrame');
    iframe.contentWindow.postMessage('submitForm', backEndUrl);
    try {
        const iframeResult = await waitForIframeResult();
        console.log('Received result from iframe:', iframeResult);
        if (iframeResult) {
            await userFormStore.updateResource(route.params.id);
        }
    } catch (error) {
        console.error('Error updating resource:', error);
    }
}

</script>

<template>
    <van-cell-group inset>
        <van-collapse v-model="name" accordion>
            <van-collapse-item name="1">
                <template #title>
                    <b>{{ userForm.name }}</b>
                </template>
                {{ userForm.description }}
            </van-collapse-item>
        </van-collapse>
        <van-cell title="Status">
            <template #value>
                <van-tag round size="medium" type="primary">{{ userForm.status }}</van-tag>
            </template>
        </van-cell>
        <van-cell title="Created By" :value="userForm.created_by_user"/>
        <van-cell title="Completed" v-if="userForm.completed_at_formatted" :value="userForm.completed_at_formatted"/>
        <van-cell title="Created" :value="userForm.created_at_formatted"/>
    </van-cell-group>

    <van-divider/>

    <van-cell-group inset>
        <iframe id="formFrame" width="100%" height="400" :src="userForm.ssr_url"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                allowfullscreen>
        </iframe>
    </van-cell-group>

    <van-divider/>

    <van-cell-group inset>
        <div v-if="userForm.next_user_resource?.id && userForm?.status === 'Completed'">
            <van-button block round type="success" :to="'/' + userForm.next_user_resource.type + '/'  + userForm.next_user_resource.id">
                Next {{userForm.next_user_resource.type}}
            </van-button>
        </div>
        <div v-if="userForm?.status !== 'Completed'">
            <van-button block round type="success" @click="updateResource">
                Submit
            </van-button>
        </div>

        <van-divider/>

        <van-button v-if="userForm.treatment_session_id" block plain round type="warning"
            :to="'/session/' + userForm.treatment_session_id">
            Back to Session
        </van-button>

    </van-cell-group>

</template>
